export const agentsSelector = state =>state.agentsReducer.agents;
export const agentPrivilegesSelector = state =>state.agentsReducer.agentPrivileges;
